<form [formGroup]="form" id="form">
  <div class="row">
    <div class="col-12 bg-cust-blue text-white pt-2">
      <h6>สร้างรายงานการติดต่อ</h6>
    </div>
  </div>

  <div class="row">
    <div class="col-11">
      <div class="row mt-3">
        <div class="col-3 text-right">
          <label class="required">ช่องทางการติดต่อ</label>
        </div>
        <div class="col-3">
          <select class="form-control" formControlName="dpa_casechannelid">
            <option selected value="">กรุณาเลือก</option>
            <option *ngFor="let c of caseChannelList" [value]="c.dpa_casechannelid">
              {{c.dpa_name}}
            </option>
          </select>
          <span class="text-danger"
            *ngIf="(formControl.dpa_casechannelid.touched || submitted) && formControl.dpa_casechannelid.errors?.required">
            กรุณาระบุช่องทางการติดต่อ
          </span>
        </div>

        <div class="col-3 text-right">
          <label class="required">สถานะรายงานการติดต่อ</label>
        </div>
        <div class="col-3">
          <input type="hidden" formControlName="dpa_casestatusid">
          <select class="form-control" formControlName="dpa_casestatusid" (change)="onCaseStatusChange()">
            <option selected value="">กรุณาเลือก</option>
            <option *ngFor="let c of caseStatusList" [value]="c.dpa_casestatusid">
              {{c.dpa_name}}
            </option>
          </select>
          <span class="text-danger"
            *ngIf="(formControl.dpa_casestatusid.touched || submitted) && formControl.dpa_casestatusid.errors?.required">
            กรุณาระบุสถานะรายงานการติดต่อ
          </span>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-3 text-right">
          <label class="required">ชื่อ</label>
        </div>
        <div class="col-3">
          <input type="text" class="form-control contact-input" formControlName="firstname">
          <span class="text-danger"
            *ngIf="(formControl.firstname.touched || submitted) && formControl.firstname.errors?.required">
            กรุณาระบุชื่อ
          </span>
        </div>

        <div class="col-3 text-right">
          <label class="">นามสกุล</label>
        </div>
        <div class="col-3">
          <input type="text" class="form-control contact-input" formControlName="lastname">
          <!-- <span class="text-danger"
            *ngIf="(formControl.lastname.touched || submitted) && formControl.lastname.errors?.required">
            กรุณาระบุนามสกุล
          </span> -->
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-3 text-right">
          <label class="required lblTelephone">หมายเลขโทรศัพท์</label>
        </div>
        <div class="col-3">
          <input type="text" class="form-control contact-input number telephone1" formControlName="telephone1">
          <span class="text-danger"
            *ngIf="(formControl.telephone1.touched || submitted) && formControl.telephone1.errors?.required">
            กรุณาระบุหมายเลขโทรศัพท์
          </span>
        </div>
        <div class="col-3 text-right">
          <label>หมายเลขโทรศัพท์ที่ติดต่อได้</label>
        </div>
        <div class="col-3">
          <input type="text" class="form-control contact-input number" formControlName="dpa_otherphone">
        </div>
      </div>

      <div class="row mt-3">

        <div class="col-3 text-right">
          <label>อีเมล</label>
        </div>
        <div class="col-3">
          <input type="email" class="form-control contact-input" formControlName="emailaddress1">
          <!-- <span class="text-danger"
            *ngIf="(formControl.emailaddress1.touched || submitted) &&
            (formControl.emailaddress1.errors?.email && email != '')">
            อีเมลไม่ถูกต้อง
          </span> -->
          <span class="text-danger"
          *ngIf="form.get('emailaddress1').invalid && (form.get('emailaddress1').dirty || form.get('emailaddress1').touched)">
            อีเมลไม่ถูกต้อง
          </span>
        </div>

        <div class="col-3 text-right">
          <label class="required">ระดับความสำคัญ</label>
        </div>
        <div class="col-3">
          <select class="form-control" formControlName="dpa_caseseverityid">
            <option selected value="">กรุณาเลือก</option>
            <option *ngFor="let c of caseSeverityList" [value]="c.dpa_caseseverityid">
              {{c.dpa_name}}
            </option>
          </select>
          <span class="text-danger"
            *ngIf="(formControl.dpa_caseseverityid.touched || submitted) && formControl.dpa_caseseverityid.errors?.required">
            กรุณาระบุระดับความสำคัญ
          </span>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-3 text-right">
          <label class="required">ประเภทรายงานการติดต่อ</label>
        </div>
        <div class="col-9">
          <select class="form-control" (change)="onCaseTypeChange()" formControlName="dpa_casetypeid">
            <option selected value="">กรุณาเลือก</option>
            <option *ngFor="let c of caseTypeList" [value]="c.dpa_casetypeid">
              {{c.dpa_name}}
            </option>
          </select>
          <span class="text-danger"
            *ngIf="(formControl.dpa_casetypeid.touched || submitted) && formControl.dpa_casetypeid.errors?.required">
            กรุณาระบุประเภทรายงานการติดต่อ
          </span>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-3 text-right">
          <label class="required">หัวข้อการติดต่อ</label>
        </div>
        <div class="col-9">
          <select class="form-control" (change)="onCaseSubTypeChange()" formControlName="dpa_casesubtypeid">
            <option selected value="">กรุณาเลือก</option>
            <option *ngFor="let c of caseSubTypeList" [value]="c.dpa_casesubtypeid">
              {{c.dpa_name}}
            </option>
          </select>
          <span class="text-danger"
            *ngIf="(formControl.dpa_casesubtypeid.touched || submitted) && formControl.dpa_casesubtypeid.errors?.required">
            กรุณาระบุหัวข้อการติดต่อ
          </span>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-3 text-right">
          <label class="required">หัวข้อย่อย</label>
        </div>
        <div class="col-9">
          <select class="form-control" formControlName="dpa_casesubtypedetailid">
            <option selected value="">กรุณาเลือก</option>
            <option *ngFor="let c of caseSubTypeDetailList" [value]="c.dpa_casesubtypedetailid">
              {{c.dpa_name}}
            </option>
          </select>
          <span class="text-danger"
            *ngIf="(formControl.dpa_casesubtypedetailid.touched || submitted) && formControl.dpa_casesubtypedetailid.errors?.required">
            กรุณาระบุหัวข้อย่อย
          </span>
        </div>
      </div>

      <div class="row mt-3">

        <div class="col-3 text-right">
          <label class="required">รายละเอียด</label>
        </div>
        <div class="col-9">
          <textarea class="form-control" rows="3" formControlName="description"></textarea>
          <span class="text-danger"
            *ngIf="(formControl.description.touched || submitted) && formControl.description.errors?.required">
            กรุณาระบุรายละเอียด
          </span>
        </div>

      </div>
      <div class="row mt-3">
        <div class="col-3 text-right">
          <label class="{{isResolvedRequired ? 'required' : ''}}">ตอบ</label>
        </div>
        <div class="col-9">
          <textarea class="form-control" rows="3" formControlName="dpa_resolution"></textarea>
          <span class="text-danger"
          *ngIf="(formControl.dpa_resolution.touched || submitted) && (formControl.dpa_resolution.value == null ||formControl.dpa_resolution.value.trim().length == 0) && isResolvedRequired">
          กรุณาระบุคำตอบ
        </span>
        </div>

      </div>

      <div class="row mt-3" *ngIf="isShowAnswerLink">
        <div class="col-8 offset-md-3 my-auto">
          <label>กลับไปตอบคำถามที่ Social Monitoring</label>
          <button class="btn btn-primary ml-2">
            Go
            <span class="fa fa-link"></span>
          </button>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-3 text-right">
          <label class="{{isRemarkRequired ? 'required' : ''}}">หมายเหตุ</label>
        </div>
        <div class="col-9">
          <textarea class="form-control" rows="3" formControlName="dpa_remark"></textarea>
          <span class="text-danger"
          *ngIf="(formControl.dpa_remark.touched || submitted) && (formControl.dpa_remark.value == null ||formControl.dpa_remark.value.trim().length == 0) && isRemarkRequired">
          กรุณาระบุหมายเหตุ
        </span>
        </div>

      </div>
      <div class="row mt-3">
        <div class="col-3 text-right">
          
        </div>
        <div class="col-3"><label >
          <input id="ra1" type="radio"   formControlName="dpa_pdpa_flag" >
          ยอมรับนโยบายความเป็นส่วนตัว
        </label></div>
        
        <div class="col-6"><label >
          <input id="ra2" type="radio"  >
          ไม่ยอมรับนโยบายความเป็นส่วนตัว
        </label></div>
      </div>

      <div class="row mt-3">

        <div class="col-3 text-right">
          <label>วันที่สร้าง Case</label>
        </div>
        <div class="col-3">
          <input type="text" class="form-control" readonly value="{{createdon | thaidate:'short'}}">
        </div>
        <div class="col-3 text-right">
          <label>วันที่ Update Case ล่าสุด</label>
        </div>
        <div class="col-3">
          <input type="text" class="form-control" readonly value="{{modifiedon | thaidate:'short'}}">
        </div>
      </div>

      <div class="row mt-3">

        <div class="col-3 text-right">
          <label>ผู้สร้างข้อมูล Case</label>
        </div>
        <div class="col-3">
          <input type="text" class="form-control" readonly value="{{createBy}}">
        </div>
        <div class="col-3 text-right">
          <label>ผู้แก้ไขข้อมูลล่าสุด</label>
        </div>
        <div class="col-3">
          <input type="text" class="form-control" readonly value="{{modifiedBy}}">
        </div>
      </div>

      <!-- <div class="row mt-3">
        <div class="col-2"></div>
        <div class="col-10 input-group">
          <button class="btn btn-info">
            <span class="fa fa-paperclip"></span>
            Attatch File
          </button>
          <input type="text" class="form-control" readonly>
        </div>
      </div> -->

    </div>
    <div class="col-1">
      <button class="btn btn-primary mt-3" (click)="openKm()" id="btnKm">
        <img src="../../assets/images/knowledge.png">
        <br>
        <span>KM</span>
      </button>
    </div>

    <!-- <div class="col-4 pt-3">
      <div class="bg-cust-blue overflow-auto" style="border-bottom-left-radius: 1rem; border-top-left-radius: 1rem; height: 90%;">
        <div class="row mt-3">
          <div class="col-12 text-center mt-3">
            <h5 class="text-white">ค้นหาตาม Keyword</h5>
          </div>
          <div class="col-12 input-group p-3">
            <input type="search" class="form-control search-field" placeholder="Search" id="kmCri" (keyup.enter)="filterKm()">
            <div class="input-group-append">
              <button class="btn btn-primary" (click)="filterKm()">
                <span class="fa fa-search"></span>
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-11 p-3 m-3 text-white" style="border-radius: 1rem; border: 1px solid white;">
            <ol class="pl-3 km-type">
              <li class="mb-3" (click)="filterByType(1)">ข้อมูลเกี่ยวกับสถาบันคุ้มครองเงินฝาก (องค์กร)</li>
              <li class="mb-3" (click)="filterByType(2)">ข้อมูลเกี่ยวกับระบบคุ้มครองเงินฝาก</li>
              <li class="mb-3" (click)="filterByType(3)">ข้อมูลเกี่ยวกับการคุ้มครองเงินฝาก (วงเงินผลิตภัณฑ์ สง.ที่คุ้มครอง)</li>
              <li class="mb-3" (click)="filterByType(4)">กระบวนการจ่ายคืน</li>
              <li class="mb-3" (click)="filterByType(5)">กระบวนการชำระบัญชี</li>
              <li class="mb-3" (click)="filterByType(6)">ความรู้ทั่วไปทางการเงิน</li>
              <li class="mb-3" (click)="filterByType(7)">อื่นๆ</li>
            </ol>
          </div>
        </div>
        <div class="row">
          <div *ngFor="let km of showingKBList">
            <div class="col-11 text-white">
              <b>{{km.dpa_name}}:</b>
            </div>
            <div class="col-11 p-3 m-3 text-white km-content" [innerHTML]="km.dpa_content"></div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</form>

<div class="row mt-5" *ngIf="!isPopupMode">
  <div class="col-12 text-center">
    <button type="button" class="btn btn-info m-2" (click)="save()" [disabled]="isEndCase">
      <span class="fa fa-check"></span>
      บันทึก
    </button>
    <button type="button" class="btn btn-info m-2" (click)="save(true)" [disabled]="isEndCase">
      <span class="fa fa-check"></span>
      บันทึกและปิด
    </button>
    <button type="button" class="btn btn-info m-2" *ngIf="role.dpa_button_reaasigncase" [disabled]="isEndCase" (click)="forward()">
      <span class="fa fa-paper-plane"></span>
      ส่งต่อ
    </button>
    <button type="button" class="btn btn-info m-2" *ngIf="!isPopupMode" (click)="closeWindow()">
      <span class="fa fa-times"></span>
      ปิด
    </button>
    <button type="button" class="btn btn-info m-2" *ngIf="isPopupMode" data-dismiss="modal">
      <span class="fa fa-times"></span>
      ปิด
    </button>
  </div>
</div>



<!-- Modal Forward-->
<div class="modal fade" id="forwardModal" tabindex="-1" role="dialog" aria-labelledby="forwardModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="forwardModalLabel">ส่งต่อรายงานการติดต่อ</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-5 text-right">
            <label class="required">ทีม</label>
          </div>
          <div class="col-7">
            <select class="form-control" [(ngModel)]="forwardTeam" (change)="onForwardTeamChange()">
              <option value="" selected>เลือก</option>
              <option *ngFor="let t of teamList" [value]="t.dpa_callcenterteamid">
                {{t.dpa_name}}
              </option>
            </select>
            <span class="text-danger" *ngIf="submittedForward && forwardTeam == ''">
              กรุณาเลือก ทีม
            </span>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right">
            <label class="">ผู้ใช้งาน</label>
          </div>
          <div class="col-7">
            <select class="form-control" [(ngModel)]="userIdReceive">
              <option value="">เลือก</option>
              <option *ngFor="let a of userList" [value]="a.dpa_customwebuserid">
                {{a.dpa_name}}
              </option>
            </select>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right">
            <label class="required">หมายเหตุ</label>
          </div>
          <div class="col-7">
            <input type="text" class="form-control" [(ngModel)]="forwardRemark">
            <span class="text-danger" *ngIf="submittedForward && forwardRemark == ''">
              กรุณาระบุ หมายเหตุ
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center mt-5">
            <button type="button" class="btn btn-info mr-2" (click)="confirmForward()">OK</button>
            <button type="button" class="btn btn-info ml-2" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal Forward-->
<div class="modal fade" id="forwardSuccessModal" tabindex="-1" role="dialog" aria-labelledby="forwardSuccessModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-success">
        <h5 class="modal-title" id="forwardSuccessModalLabel">Success</h5>
      </div>
      <div class="modal-body bg-success">
        <div class="row">
          <div class="col-12">
            <label>ส่งต่อสำเร็จ</label>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-right mt-5">
            <button type="button" class="btn btn-default mr-2" (click)="closeForwardSuccess()">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>





// WEBPACK FOOTER //
// ./src/app/new-case/new-case.component.html